import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where, } from 'firebase/firestore';
import { auth, db, } from '../firebase';
import { useParams } from 'react-router-dom';

export default function Avakdetails() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);

    const [avakitems, setavakitems] = useState([]);
    const [searchText, setsearchText] = useState("");

    const [updocid, setupdocid] = useState("");
    const { documentId } = useParams();



    const [productid, setproductid] = useState(" ");
    const [rate, setrate] = useState(0);
    const [quantity, setquantity] = useState(0);
    const [size, setsize] = useState(" ");
    const [products, setproducts] = useState([]);


    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);



    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchPropid()
        });
    });

    const fetchPropid = async () => {
        if (userData) {
            if (loadincount) {
                const docRef = doc(db, "users", userData.uid)
                const docSnap = await getDoc(docRef)
                if (docSnap.exists()) {
                    fetchData1();
                    setloadincount(false)
                }
            }
        }
    }

    const fetchData1 = async () => {
        try {
            const q = query(collection(db, "avakitems"), where("avakid", "==", documentId));
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                const fetchedItems = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setavakitems(fetchedItems);
            } else {
                console.log("No matching documents found!");
            }

            const q1 = query(collection(db, 'products'))
            onSnapshot(q1, (querySnapshot) => {
                setproducts(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });


        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchData2 = async () => {
        try {
            const filteredData = avakitems.filter((item) =>
                item.data.avakpersonname.toUpperCase().includes(searchText.toUpperCase())
            );
            setavakitems(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }



    const handleDelete = async (docid,) => {

        const taskDocRef = doc(db, 'avakitems', docid)
        await deleteDoc(taskDocRef)
        Toast.fire({
            icon: "success",
            title: 'Avak Item Deleted Successfully!!'
        });
        
        fetchData1();
    }

    const handleEdit = (id, productid, quantity, size, rate) => {
        setupdocid(id);
        setproductid(productid)
        setquantity(quantity)
        setsize(size)
        setrate(rate)
    }

    const handleUpdate = async () => {
        try {
            let product = "";
            const docRef1 = doc(db, "products", productid);
            const docSnap1 = await getDoc(docRef1);
    
            if (docSnap1.exists()) {
                product = docSnap1.data().product;
            } else {
                product = " ";
            }
    
            // Step 1: Update the specific avakitems document
            await updateDoc(doc(db, "avakitems", updocid), {
                product: product,
                productid: productid,
                quantity: parseFloat(quantity),
                size: size,
                rate: rate,
            });
    
            // Step 2: Fetch all avakitems related to the same avakRegisterId
            const q = query(collection(db, "avakitems"), where("avakid", "==", documentId));
            const querySnapshot = await getDocs(q);
    
            const avakItemsArray = querySnapshot.docs.map(doc => ({
                ...doc.data()
            }));
    
            // Step 3: Calculate the total of all rates
            const allTotal = avakItemsArray.reduce((sum, item) => parseFloat(sum) + (parseFloat(item.rate) || parseFloat(0)), 0);
    
            // Step 4: Update avakregisters with avakitems array & allTotal
            const avakRegisterRef = doc(db, "avakregisters", documentId);
            await updateDoc(avakRegisterRef, {
                avakitems: avakItemsArray,
                alltotal: allTotal
            });
    
            // Step 5: Show success toast
            Toast.fire({
                icon: "success",
                title: "Avak Items Updated Successfully!!"
            });
    
            // Step 6: Refresh data
            fetchData1();
        } catch (error) {
            console.error("Error updating documents:", error);
        }
    };
    

    const handleprodChange = (value) => {
        setproductid(value);
        setrate(0);
        setquantity(0);

    }




    return (
        <div>
            <div className="content-wrapper">
                <br />

                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " style={{ float: "right", textTransform: "uppercase" }} >|| View Avak Items ||</button><br /><br /><br />
                        <div className="card card-primary card-outline ex1">
                            <div className=" p-1">
                                &nbsp;&nbsp;<input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4' placeholder='Type here......' />&nbsp;
                            </div>
                            <div className="card-body table-responsive p-0" >

                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Action</th>
                                            <th>Sr No</th>
                                            <th>Product </th>
                                            <th>Quantity </th>
                                            <th>Size </th>
                                            <th>Rate </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            avakitems.map((item, num = 1) =>
                                                <tr key={num + 1}>
                                                    <td>
                                                        <a onClick={() => handleEdit(item.id, item.productid, item.quantity, item.size, item.rate)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-success" > <i className="fa fa-edit"></i></a>&nbsp;
                                                        <a onClick={() => { if (window.confirm('Are u sure?')) { handleDelete(item.id) }; }} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>&nbsp;
                                                    </td>
                                                    <td width="80">{num + 1}</td>
                                                    <td>{item.product}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{item.size}</td>
                                                    <td>{item.rate}</td>


                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* ============================================= modal start ================================================= */}




            <div className="modal fade" id="text-modal1">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Avak Items</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-sm-3'>
                                    <label>Product Id</label>
                                    <input
                                        list="products-list"
                                        className="form-control"
                                        value={productid}
                                        onChange={(e) => handleprodChange(e.target.value)}
                                        placeholder="Select Product"
                                    />
                                    <datalist id="products-list">
                                        {
                                            products.map((item, index) => (
                                                <option key={index} value={item.id}>{item.data.product}</option>
                                            ))
                                        }
                                    </datalist>
                                </div>

                                <div className='col-sm-3'>
                                    <label>Quantity</label>
                                    <input type="number" value={quantity} onChange={(e) => setquantity(e.target.value)} className="form-control" />
                                </div>
                                <div className='col-sm-3'>
                                    <label>Size</label>
                                    <input type="text" value={size} onChange={(e) => setsize(e.target.value)} className="form-control" />
                                </div>
                                <div className='col-sm-3'>
                                    <label>Rate</label>
                                    <input type="number" value={rate} onChange={(e) => setrate(e.target.value)} className="form-control" />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Update </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
